import React from "react";
import ui from "../../pages/dashboard/DashboardUI.module.css";

// Label + control + hint/error in the same style FormModal uses for its fields.
export default function Field({ label, error, hint, children }) {
  return (
    <div className={ui.inputGroup}>
      {label && <label>{label}</label>}
      {children}
      {error ? <span role="alert" style={{ color: "#dc2626", fontSize: "0.78rem" }}>{error}</span>
        : hint && <span style={{ color: "#64748b", fontSize: "0.78rem" }}>{hint}</span>}
    </div>
  );
}
